import React from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Users from "./pages/users/Users";
import Stories from "./pages/stories/Stories";
import Dashboard from "./pages/dashboard/dashboard";

import { BrowserRouter, Route, Routes } from "react-router-dom";
import Login from "./pages/login/Login";
import ForgotPassword from "./pages/forgotPassword/ForgotPassword";
import VerifyOtp from "./pages/otpVerification/VerifyOtp";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import Admins from "./pages/admins/Admins";
import ViewUser from "./pages/viewUser/ViewUser";
import ViewStory from "./pages/viewStory/ViewStory";
import ViewAdmins from "./pages/viewAdmins/ViewAdmins";
import PrivacyPolicy from "./pages/privacyPolicy/PrivacyPolicy";
import TermsAndConditions from "./pages/termsAndConditions/TermsAndConditions";
import Character from "./pages/character/Character";
import SiteSettings from "./pages/siteSettings/SiteSettings";
import Messages from "./pages/messages/Messages";
import Nav from "./components/nav/Nav";
import Questions from "./pages/questions/Questions";
import Answers from "./pages/answers/Answers";
import Instructions from "./pages/instructions/Instructions";
import VideoStatistics from "./pages/videoStatistics/VideoStatistics";
import ViewVideoStatistics from "./components/videoStatistics/ViewVideoStatistics";
import SpecialFeatures from "./pages/specialFeatures/SpecialFeatures";
import Register from "./pages/register/Register";
import { ToastContainer } from "react-toastify";
import ViewInstruction from "./components/instructions/ViewInstruction";
import ViewAnswer from "./components/answers/ViewAnswer";
import Profile from "./pages/profile/Profile";
//import { createClient } from '@supabase/supabase-js'
//import { SUPABASE_API_KEY, SUPABASE_URL } from "./config/Api_url";
//const supabaseUrl = SUPABASE_URL
//const supabaseKey = SUPABASE_API_KEY
//const supabase = createClient(supabaseUrl, supabaseKey)

const App = () => {
  // const [activeIndex, setActiveIndex] = useState(0);

  // const handleNavClick = (index) => {
  //   setActiveIndex(index);
  // };

  return (
    <BrowserRouter>
      {/* <Nav activeIndex={activeIndex} onNavClick={handleNavClick} /> */}
      <Nav />

      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/verify-otp" element={<VerifyOtp />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/admins" element={<Admins />} />
        <Route path="/view-user/:id" element={<ViewUser />} />
        <Route path="/view-story/:id" element={<ViewStory />} />
        <Route path="/view-admin/:id" element={<ViewAdmins />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/character" element={<Character />} />
        <Route path="/site-settings" element={<SiteSettings />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/answers" element={<Answers />} />
        <Route path="/view-answer/:id" element={<ViewAnswer />} />
        <Route path="/instructions" element={<Instructions />} />
        <Route path="/view-instruction/:id" element={<ViewInstruction />} />
        <Route path="/video-statistics" element={<VideoStatistics />} />
        <Route
          path="/view-video-statistics"
          element={<ViewVideoStatistics />}
        />
        <Route path="/special-features" element={<SpecialFeatures />} />
        <Route path="/profile" element={<Profile />} />
      </Routes>
      <ToastContainer
        position="bottom-center"
        autoClose={3000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />
    </BrowserRouter>
  );
};

export default App;
